export enum ClaimState {
  ACTIVE = "ACTIVE",
  SUSPENTION = "SUSPENTION",
  INTENTION = "INTENTION",
  PAY = "PAY",
}

export interface Claims {
  id: number;
  state: ClaimState;
  amount: number;
  balance: number;
}